const KEY = "hm-landing";

export function captureLanding() {
  if (sessionStorage.getItem(KEY)) return;
  const q = new URLSearchParams(window.location.search);
  sessionStorage.setItem(
    KEY,
    JSON.stringify({
      referrer: document.referrer || "",
      landing_page: window.location.pathname,
      utm_source: q.get("utm_source") || "",
      utm_medium: q.get("utm_medium") || "",
      utm_campaign: q.get("utm_campaign") || "",
      gclid: q.get("gclid") || "",
    })
  );
}

export function trackConversion() {
  if (typeof window.gtag === "function") {
    window.gtag("event", "conversion", { send_to: "AW-18501236075/VOpdCMvfv5YdEOvqifZE" });
  }
}

export function trackingPayload(lang) {
  let landing = {};
  try {
    landing = JSON.parse(sessionStorage.getItem(KEY) || "{}");
  } catch {
    landing = {};
  }
  return { lang, page: window.location.pathname, browser_lang: navigator.language || "", ...landing };
}
